<template>
  <div class="q-wrap" style="background: rgba(241,245,249,0.5); padding: 12px; border-radius: 8px; border: 1px solid #e2e8f0; margin-bottom: 8px;">
    <div class="q-row" style="flex-direction:row; justify-content:space-between; align-items:center;">
      <span class="q-label" style="color:#6366f1;">
        {{ question.numero_pregunta || question.id }} Subpregunta CAMPOS 
      </span>
      <button type="button" class="q-remove-btn" @click="remove" style="width:20px;height:20px;">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>
      </button>
    </div>

    <div class="q-row" v-if="parentType === 'SELECCION_CONDICIONAL'">
      <label class="q-label">Respuesta asociada</label>
      <select class="q-input" v-model="question.assignment">
        <option disabled selected>Seleccione una</option>
        <option  v-for="(option, oIndex) in parentOptions" :key="'option' + oIndex" :value="option">{{ option }}</option>
      </select>
      <p v-if="question.assignmentError" class="q-error-msg">Debes seleccionar una respuesta asociada.</p>
    </div>

    <div class="q-row">
      <input class="q-input" :class="{ 'q-input--error': question.error }" type="text" placeholder="Escribe la subpregunta aqui..." v-model="question.texto" />
      <p v-if="question.error" class="q-error-msg">Ingrese la pregunta.</p>
    </div>
    
    <div class="q-row">
      <input class="q-input" type="text" placeholder="Instruccion o aclaracion..." v-model="question.nota_para_registrante" />
    </div>

    <div class="q-row" style="flex-direction:row; justify-content:space-between; align-items:center; margin-top:4px;">
      <span class="q-label" style="margin:0">Campos a llenar</span>
      <button type="button" class="q-add-btn" @click="addField">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/></svg>
        Agregar
      </button>
    </div>
    <p v-if="question.fieldError" class="q-error-msg">Llenar nombre de todos los campos.</p>
    <p v-if="question.minimumError" class="q-error-msg">Debe haber al menos un campo.</p>

    <div class="q-row">
      <div v-for="(field, index) in question.campos" :key="index" class="q-option-row">
        <span class="q-option-prefix">{{ index + 1 }}.</span>
        <input class="q-input" :class="{ 'q-input--error': field.texto === '' && question.fieldError }" type="text" placeholder="Nombre de campo" v-model="question.campos[index].texto" />
        <select class="q-input" style="width: auto; min-width: 120px;" v-model="question.campos[index].tipo">
          <option value="texto">Texto</option>
          <option value="numero">Número</option>
          <option value="fecha">Fecha</option>
          <option value="hora">Hora</option>
        </select>
        <button v-if="question.campos.length > 1" type="button" class="q-remove-btn" @click="removeField(index)">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "fields-sub-question",
  data() { return { maxOptions: 25 }; },
  mounted() {
    this.fetchConfiguration();
  },
  methods: {
    fetchConfiguration() {
      this.axios.get("apidev/api/config/site").then(response => {
        if (response.data && response.data.config && typeof response.data.config.max_question_options === "number") {
          this.maxOptions = response.data.config.max_question_options;
        }
      }).catch(() => {});
    },
    remove() { this.$emit("click"); },
    addField() {
      if (this.question.campos.length < this.maxOptions) {
        this.question.campos.push({ texto: "", tipo: "texto" });
        this.question.minimumError = false;
      }
    },
    removeField(index) {
      if (this.question.campos.length > 1) {
        this.question.campos.splice(index, 1);
      } else { this.question.minimumError = true; }
    },
    validateQuestion() {
      let valid = true;
      if (this.parentType === "SELECCION_CONDICIONAL") {
        if (!this.question.assignment || this.question.assignment === "Seleccione una") {
          this.question.assignmentError = true;
          valid = false;
        } else { this.question.assignmentError = false; }
      }
      if (this.question.texto === "") { this.question.error = true; valid = false; } else { this.question.error = false; }
      if (this.question.campos.some(c => c.texto === "")) { this.question.fieldError = true; valid = false; } else { this.question.fieldError = false; }
      if (this.question.campos.length < 1) { this.question.minimumError = true; valid = false; } else { this.question.minimumError = false; }
      return valid;
    }
  },
  props: { question: { required: true, type: Object }, parentType: { required: false, type: String }, parentOptions: { required: false, type: Array } }
};
</script>
<style scoped>
.q-wrap { display: flex; flex-direction: column; gap: 8px; font-size: 0.82rem; }
.q-row { display: flex; flex-direction: column; gap: 4px; }
.q-inline-row { display: flex; align-items: flex-end; gap: 14px; flex-wrap: wrap; }
.q-label { font-size: 0.65rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.05em; color: #64748b; }
.q-input { width: 100%; padding: 6px 10px; border: 1px solid #cbd5e1; border-radius: 7px; background: #fff; color: #334155; font-size: 0.8rem; transition: border-color 0.15s, box-shadow 0.15s; outline: none; box-sizing: border-box; }
.q-input:focus { border-color: #6366f1; box-shadow: 0 0 0 3px rgba(99,102,241,0.12); }
.q-input--error { border-color: #f87171 !important; }
.q-error-msg { font-size: 0.7rem; color: #ef4444; margin: 0; }
.q-check-row { display: flex; align-items: center; gap: 6px; }
.q-check-row input[type=checkbox] { width: 14px; height: 14px; accent-color: #6366f1; cursor: pointer; }
.q-check-row span { font-size: 0.72rem; font-weight: 600; text-transform: uppercase; color: #475569; }
.q-remove-btn { display: flex; align-items: center; justify-content: center; width: 22px; height: 22px; border: 1px solid #fca5a5; border-radius: 5px; background: #fef2f2; color: #ef4444; cursor: pointer; flex-shrink: 0; transition: all 0.15s; }
.q-remove-btn:hover { background: #fee2e2; }
.q-add-btn { display: inline-flex; align-items: center; gap: 4px; padding: 4px 10px; border: 1px solid #e2e8f0; border-radius: 6px; background: #fff; color: #475569; font-size: 0.72rem; font-weight: 600; cursor: pointer; transition: all 0.15s; }
.q-add-btn:hover { background: #e2e8f0; }
.q-option-row { display: flex; align-items: center; gap: 6px; }
.q-option-prefix { font-size: 0.72rem; color: #94a3b8; min-width: 18px; text-align: right; flex-shrink: 0; }
</style>
